export default __webpack_public_path__ + "static/media/man-computer-emoji.ba916ca7.png";